import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import TaskDetailPage from './components/TaskDetailPage';
import authService from './services/authService';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    // Проверяем, есть ли сохраненный токен при загрузке приложения
    const checkAuthStatus = () => {
      const isAuth = authService.isAuthenticated();
      console.log('App - Auth check result:', isAuth);
      setIsAuthenticated(isAuth);
      setIsLoading(false);
    };

    checkAuthStatus();
  }, []);

  const handleLoginSuccess = () => {
    console.log('App - Login success, setting authenticated to true');
    // Сразу устанавливаем состояние аутентификации в true
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    console.log('App - Logging out');
    try {
      await authService.logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        {isAuthenticated ? (
          <Routes>
            <Route path="/dashboard" element={<Dashboard onLogout={handleLogout} />} />
            <Route path="/task/:taskId" element={<TaskDetailPage />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        ) : (
          <LoginPage onLoginSuccess={handleLoginSuccess} />
        )}
      </div>
    </Router>
  );
}

export default App; 